import React, {Component, PropTypes} from 'react'
import {connect} from "react-redux"
import styles from './b2bCompanyClientProfile.scss'
import {setB2bCompanyOpened, setB2bCompanySubModule} from 'state/actions'
import KeyValue from '../KeyValue'
import i18n from 'lib/i18n'
const _ = i18n('clientProfile')

import {formatDate} from 'lib/helpers'
const DateValue = ({date, ...rest}) => (
	<span {...rest}>{formatDate(date)}</span>
)

const printSelect = (item, options) => {
    let itemValue = "";

    options.map((key, i) => {
        if (Number(item) == Number(key.value)) {
            itemValue = key.label
        }
    })

    return itemValue
}

const clientLanguagePrintSelect = ( item, options, language, languageOptions) => {
    let convertedLanguage;

    // Generate langauge code from 
    if(isNaN(language))
    {
           languageOptions.map((index, key) => {
                if(index.label == language)
                {
                    language = index.value
                }
           })
    }

    if(language == 1)
    {
        language = 'nl';   
    }
    else if(language == 2)
    {
        language = 'fr';
    }
    else if(language == 3)
    {
        language = 'en';
    }
    else
    {
        language = 'nl'
    }

    options.map((index, key) => {
        if(index.value == item)
        {
            convertedLanguage = index.label[language]    
        }
    })

    return convertedLanguage
}

/**
 * Generates the client dictionaries to have a same place for each dictionary
 *
 * @param Object clientOptionsDictionary 	The translate list from state.client.clientOptionsDict
 * @param string language 								The language of the application - state.app.lang
 */
const generateClientDicts = (clientOptionsDict, language) => {
    const clientDictionaries = []

    clientDictionaries['personType'] 			= generateOptionsObject(clientOptionsDict.PERSOONSTYPE, language)
    clientDictionaries['gender']     			= generateOptionsObject(clientOptionsDict.GESLACHT, language)
    clientDictionaries['nationality'] 		    = generateOptionsObject(clientOptionsDict.NATIONALITEIT, language)
    clientDictionaries['language']				= generateOptionsObject(clientOptionsDict.TAAL, language)
    clientDictionaries['title']					= generateOptionsObject(clientOptionsDict.AANSPREKING, language)
    clientDictionaries['licenceCategory']       = generateOptionsObject(clientOptionsDict.RB_CATEGORIE, language)
    clientDictionaries['relationType']          = generateOptionsObject(clientOptionsDict.HOEDANIGHEID, language)
    clientDictionaries['country']				= generateOptionsObject(clientOptionsDict.LAND, language)
    clientDictionaries['legalForm']             = generateOptionsObject(clientOptionsDict.RECHTSVORM, language)
    clientDictionaries['globalCountry']         = generateGlobalOptionsObject(clientOptionsDict.LAND)

    return clientDictionaries
}

const generateGlobalOptionsObject = (optionsData) => {
    const optionsArray = []

    Object.keys(optionsData).map((key,index) => {
        optionsArray.push({value:key, label: optionsData[key]})
    })

    return optionsArray
}

/**
 * Generate option array based on requested object data
 * @param Object optionsData
 * @param String language
 *
 * @return array
 */
const generateOptionsObject = (optionsData, language) => {
    const optionsArray = []

    Object.keys(optionsData).map((key, index) => {
        optionsArray.push({value: key, label: optionsData[key][language]})
    });

    return optionsArray
}

const AddressValue = ({addressData, clientOptionsDict, clientLanguage}) => {
    const {country, street, number, extension, postalCode, locality} = addressData
    return(
        <div>
            {street} {number}{extension ? '/' + extension : ''} <br/>
            {postalCode} {locality} {!isNaN(country) ? clientLanguagePrintSelect(country, clientOptionsDict.globalCountry, clientLanguage, clientOptionsDict.language): country}
        </div>
    )
}
const PhoneValue = ({number}) => 
	<p className={number.default === "true" && styles.defaultNumber}>
		<a href={`callto:${number.number}`}>{number.number}</a>
		<a href={`callto:${number.phone}`}>{number.phone}</a>
	</p>

const BankAcctValue = ({BIC, IBAN}) => (
	<div>
		<span style={{fontWeight: 'bold'}}>{IBAN}</span><br/>
		<span style={{fontStyle: 'italic'}}>{BIC}</span>
	</div>
)
const DriversLicenseValue = ({licenceCategory, licenceDate}) => (
	<div>
		{licenceCategory}
		{licenceDate && <span> (<DateValue date={licenceDate}/>)</span>}
	</div>
)
const EasinsureValue = ({eDate}) => (
	<div>
		{eDate && <DateValue date={eDate}/>}
	</div>
)
const multiLineEmail = (data) => (
	data && data.map((line, i) => (
		<p key={i}>
			<a className={(line.default == 'true') ? styles.emailDefault : styles.email} href={`mailto:${line.email}`}>
				{line.email}
			</a>
		</p>
	))
)
const multiLinePhones = (data) => (
	data && data.map((line, i) => (
		<p key={i}>
			<a className={(line.default == 'true') ? styles.phoneDefault : styles.phone} href={`callto:${line.number}`}>
				{line.number}
			</a>
		</p>
	))
)
const EmailValue = ({email}) => (
	<a className={styles.mail} href={`mailto:${email}`}>{email}</a>
)
const ContactValue = ({contactData, clientOptionsDict}) => {
    let {contactNumber, contactType, contactName, contactFirstName, contactgender, contactdateOfBirth} = contactData
    
    if(contactgender == 'M')
    {
        contactgender = 1   
    }

    if(contactgender == 'V')
    {
        contactgender = 2   
    }
    return (
        <div>
            <p>
                <span style={{fontWeight: 'bold'}}>{ !isNaN(contactType) ? printSelect(contactType,clientOptionsDict.relationType) : contactType }</span> {contactName} {contactFirstName} ( {contactNumber} )
            </p>
            {_('dateOfBirth')} {formatDate(contactdateOfBirth, 'eu')}<br/>
            {_('gender')} {!isNaN(contactgender) ? printSelect(contactgender,clientOptionsDict.gender) : contactgender}<br/>
        </div>
    )
}
const UList = ({children}) => (
	<ul>{children.map((c, i) => <li key={i}>{c}</li>)}</ul>
)

export const ClientProfileDom = ({
	clientId,
	clientDocuments,
	clientNumber, dateOfBirth, companyRegistrationNumber,
	gender, language, emails, licences, phoneNumbers, accountNumbers, contacts, myEasinsure,
	address, corrAddr, name, createClientAccess, updateClientAccess, setSubModule, clientOptionsDict
}) => {

	const columns = clientNumber && [
		[
			{label: `${_('clientNumber')}:`, value: clientNumber},
			{label: `${_('gender')}:`, value: gender},
			{label: `${_('language')}:`, value: language},
			{
				label: `${_('email')}:`,
				value: multiLineEmail(emails),
			},
			{
				label: `${_('licenceDate')}:`,
				value: <UList>{licences.map((license, i) => <DriversLicenseValue key={i} {...license}/>)}</UList>,
			},
			{label: `${_('address')}:`, value: <AddressValue addressData={address} clientOptionsDict={clientOptionsDict} clientLanguage={language}/>},
			{
				label: _('easinsureDate') + ":",
				value: <EasinsureValue eDate={myEasinsure}/>,
			},
		],
		[
			{label: `${_('dateOfBirth')}:`, value: <DateValue date={dateOfBirth}/>},
			{label: `${_('companyRegistrationNumber')}:`, value: companyRegistrationNumber},
			{
				label: `${_('phoneNumbers')}:`,
				value: multiLinePhones(phoneNumbers),
			},
			{
				label: `${_('IBAN')}:`,
				value: <UList>{accountNumbers.map((account, key) => <BankAcctValue {...account} key={key}/>)}</UList>,
			},
			{
				label: `${_('familyRelations')}:`,
				value: <UList>{contacts.map((c, i) => <ContactValue key={i} contactData={c} clientOptionsDict={clientOptionsDict} />)}</UList>,
			},
			{label: `${_('correspondence')}:`, value: <AddressValue addressData={corrAddr} clientOptionsDict={clientOptionsDict} clientLanguage={language}/>},
		],
	]

	return (
		<div className={styles.profileClient}>
			<div className={styles.moduleSection}>
				<div className={styles.moduleSectionHeading}>
					{name}

					<div className={styles.editClientProfile}>
                        {updateClientAccess && <button className="btn green" onClick={() => setSubModule('edit-profile')}>{_('edit-profile')}</button>}
					</div>
				</div>
				<div className={styles.moduleSectionContent}>
					{columns ? (
						<KeyValue array={columns} divider/>
					) : '…'}
				</div>
			</div>
		</div>
	)
}

@connect(state => {
    const clientId = state.b2bCompany.opened
    const clientAccess = state.app.security.actions
	const appLanguage = state.app.lang

	let canCreateClient,canUpdateClient
	
	// Generate options for client select lists
    const clientOptionsDict = generateClientDicts(state.client.clientOptionsDict, appLanguage)

    clientAccess.map((item, key) => {
        if(item.actionName == 'createclient')
        {
            canCreateClient = item.actionAllowed === "true" ? true : false
        }

        if(item.actionName == 'modifyclient')
        {
            canUpdateClient = item.actionAllowed === "true" ? true: false
        }
    })

    return ({
        subModule: state.clients.subModule,
        createClientAccess: canCreateClient,
        updateClientAccess: canUpdateClient,
		clientId: clientId,
		clientOptionsDict
    })
})

export default class ClientProfile extends Component {
	static propTypes = {
		clientId: PropTypes.string.isRequired,
		data: React.PropTypes.object,
	}

    setSubModule(subModuleName) {
        const {dispatch, clientId} = this.props

        dispatch(setB2bCompanyOpened(clientId))
        dispatch(setB2bCompanySubModule(subModuleName))
    }

	render() {
		const {clientId, data, createClientAccess, updateClientAccess, clientOptionsDict} = this.props
		const detail = data && data.detail || {}
		const main = data && data.main || {}
		const clientDocuments = data && data.clientDocuments || []

		const {clientNumber, dateOfBirth, companyRegistrationNumber, name} = main
		const {gender, language, emails, licences, phoneNumbers, accountNumbers, contacts, myEasinsure} = detail
		const address = data && main.mainAddress
		const corrAddr = data && detail.correspondanceAddress

        const setSubModule = (item) => {
            this.setSubModule(item)
        }

        return (
			<ClientProfileDom
				{...{
					clientId,
					clientDocuments,
					clientNumber, dateOfBirth, companyRegistrationNumber,
					gender, language, emails, licences, phoneNumbers, accountNumbers, contacts,
					address, corrAddr, myEasinsure, name,
                    createClientAccess, updateClientAccess, clientOptionsDict
				}}
				setSubModule={setSubModule}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./components/b2bCompany/b2bCompanyClientProfile.jsx